// extracted by mini-css-extract-plugin
export var boxItems = "_2b-1";
export var boxItemsLg = "_2b-2";
export var button = "_2b-7";
export var buttonHoverless = "_2b-9";
export var buttonLg = "_2b-8";
export var filterGroupBox = "_2b-0";
export var icon = "_2b-3";
export var iconSecondary = "_2b-6";
export var iconWrapper = "_2b-4";
export var iconWrapperLg = "_2b-5";
export var truncatedLabel = "_2b-a";